import { z } from 'zod';

export const advisorSchema = z.object({
  nombre: z
    .string()
    .min(1, 'Ingrese el nombre')
    .min(2, 'El nombre debe tener al menos 2 caracteres')
    .max(100, 'El nombre no puede superar 100 caracteres'),
  documento: z
    .string()
    .min(1, 'Ingrese el documento')
    .min(5, 'El documento debe tener al menos 5 caracteres')
    .max(20, 'El documento no puede superar 20 caracteres'),
  correo: z.string().min(1, 'Ingrese el correo').email('Ingrese un correo válido'),
  celular: z
    .string()
    .min(1, 'Ingrese el celular')
    .min(10, 'El celular debe tener al menos 10 dígitos')
    .max(15, 'El celular no puede superar 15 dígitos'),
  proyectoIds: z.array(z.string()).min(1, 'Seleccione al menos un proyecto'),
});

export type AdvisorFormValues = z.infer<typeof advisorSchema>;
